import { render, staticRenderFns } from "./ThreadInputTab.vue?vue&type=template&id=4976047e&scoped=true&lang=pug"
import script from "./ThreadInputTab.vue?vue&type=script&lang=js"
export * from "./ThreadInputTab.vue?vue&type=script&lang=js"
import style0 from "./ThreadInputTab.vue?vue&type=style&index=0&id=4976047e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976047e",
  null
  
)

export default component.exports